import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NotFoundPageComponent } from './not-found-page.component';
import { MessagePageModule } from '../message-page/message-page.module';

@NgModule({
  imports: [CommonModule, MessagePageModule],
  declarations: [NotFoundPageComponent],
  exports: [NotFoundPageComponent],
})
export class NotFoundPageModule {}
